"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDropdownToggle = void 0;
var react_1 = __importDefault(require("react"));
var FaIcon_1 = require("../util/FaIcon");
var AcButton_1 = require("../button/AcButton");
// https://react-bootstrap.github.io/components/dropdowns/#custom-dropdown-components
exports.AcDropdownToggle = react_1.default.forwardRef(function (props, ref) {
    var onClick = props.onClick, disableDropdownIcon = props.disableDropdownIcon, toggleSize = props.toggleSize, children = props.children, rest = __rest(props, ["onClick", "disableDropdownIcon", "toggleSize", "children"]);
    var handleClick = function (e) {
        e.preventDefault();
        if (onClick) {
            onClick(e);
        }
    };
    return (react_1.default.createElement(AcButton_1.AcButton, __assign({ block: true, ref: ref, onClick: handleClick, size: toggleSize }, rest),
        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between flex-nowrap min-width-0" },
            children,
            !disableDropdownIcon && (react_1.default.createElement(FaIcon_1.FaIcon, { icon: "fas fa-caret-down", className: "toggle-icon " + (toggleSize === 'sm' ? 'ml-1' : 'ml-3'), size: "default" })))));
});
exports.AcDropdownToggle.displayName = 'AcDropdownToggle';
//# sourceMappingURL=AcDropdownToggle.js.map